export default "__VITE_ASSET__Y15bF3l5__"